const isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
const gtag = window['gtag'];

export function analyticsUserProps(profile) {
	gtag('set', 'user_properties', {
		'Guest': (profile.data.profile && profile.data.profile.name) ? "No" : "Yes",
		'First_Order': profile.data.totalOrderCount > 0 ? "No" : "Yes",
		'Fulfilled_Order_Count': profile.data.totalOrderCount - (profile.data.rejectedOrderCount + profile.data.canceledOrderCount),
		'Device_Type': isMobile ? 'Mobile Web' : 'Desktop Web',
		'Language': document.documentElement.lang.toUpperCase(),
	});
};

export function pushGoogleAnalytics4Event(profile, event_name: string, event_params?) {
	gtag('event', event_name, {
		...event_params,
		'LoggedIn': (profile.data.profile && profile.data.profile.name) ? true : false,
		'First_Order': profile.data.totalOrderCount > 0 ? false : true,
		'Device_Type': isMobile ? 'Mobile Web' : 'Desktop Web',
		'Language': document.documentElement.lang.toUpperCase(),
	});
};
